import React from 'react';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';

export default propsString => component => React.memo(component,
  (prevProps, nextProps) => {
    const cmpPrevProps = pick(prevProps, propsString);
    const cmpNextProps = pick(nextProps, propsString);
    return isEqual(cmpPrevProps, cmpNextProps);
  });
